import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AutoBindComponent from "../common/AutoBindComponent";
import unsavedDataDialogHandler from "../common/UnsavedDataDialogHandler";
import convertToLabelValuePair from "../../util/convertToLabelValuePair.js";
import * as types from "../../constants/ComponentConstants";
import mergeDeep from "../../util/mergeDeep";

import SimulatiePerInfrastructuurForm from "./SimulatiePerInfrastructuurForm";
import SimulatiePerInfrastructuurPageHelper from "./SimulatiePerInfrastructuurPageHelper";
import * as simulatiePerInfrastructuurActions from "../../actions/simulatiePerInfrastructuurActions";
import * as simulatieDossierActions from "../../actions/simulatieDossierActions";
import * as layoutActions from "../../actions/layoutActions";
import ConfirmModal from "../common/ConfirmModal";

import EasterEggHandler from "../common/EasterEggHandler";
import * as pageConstants from "../../constants/EasterEggConstants";
import redirector from "../../util/redirector.js";

import GenerateGuid from "../../util/guid";
import SimulatiePerInfrastructuurEditInfrastructuurForm from "./SimulatiePerInfrastructuurEditInfrastructuurForm";
import { orderByPropertyName } from "../../util/orderBy";

class SimulatiePerInfrastructuurPage extends AutoBindComponent {
	constructor(props) {
		super(props);

		this.state = {
			hasUnsavedChanges: false,
			showEditInfrastructuurForm: false,
			errors: [],
			center: {
				lat: '',
				lng: ''
			},
			mapKey: GenerateGuid(),
			infrastructuurMapKey: GenerateGuid(),
			inEditMode: false,
			draggable: true,
			hideAndereSoortInfrastructuur: false,
			currentSportinfrastructurenInDeBuurtIndex: null,
			showLegend: false,
			removeModalIsOpen: false,
			removeInfraIndex: null,
			isNew: false,
			addModalIsOpen: false,
			infrastructuurDraggable: true,
			sportInfrastructuurAanvraagCoordinaten: {
				lat: '',
				lng: ''
			},
			currentSportinfrastructuurInDeBuurt: null,
			infraBinnen600m: false
		};

		this.pageHelper = new SimulatiePerInfrastructuurPageHelper(this, redirector);

		this.prefillHelper = new EasterEggHandler(this, pageConstants.SIMULATIEPERINFRASTRUCTUUR);
	}

	componentDidMount() {
		this.prefillHelper.bind();
	}
	componentWillUnmount() {
		this.prefillHelper.unbind();
	}

	componentWillMount() {
		this.pageHelper.init();
	}

	componentWillReceiveProps(nextProps) {
		const { infrastructuurId } = nextProps.params;

		this.pageHelper.reloadIfRecievedFromNew(nextProps);

		const soortenInfrastructuur = nextProps.soortenInfrastructuur;
		if (soortenInfrastructuur && soortenInfrastructuur.length > 0 && nextProps.simulatiePerInfrastructuur) {
			if (!nextProps.simulatiePerInfrastructuur.andereInfrastructurenBeschikbaar || nextProps.simulatiePerInfrastructuur.andereInfrastructurenBeschikbaar === false) {
				this.setState({
					hideAndereSoortInfrastructuur: true
				});
			}
		}
	}

	handleOnChange(event, i, data) {
		this.pageHelper.change(event, i);
	}

	handleOnSave(newModelToSave) {
		this.pageHelper.save(newModelToSave.id ? newModelToSave : null);
	}

	handleOnSaveSimulatiePerInfrastructuur() {
		this.pageHelper.saveSimulatiePerInfrastructuur();
	}

	handleOnBevestigLocatie() {
		let currentSportinfrastructuurInDeBuurt = this.state.currentSportinfrastructuurInDeBuurt;
		currentSportinfrastructuurInDeBuurt.breedtegraad = this.state.newCoordinatesInfrastructuur.lat;
		currentSportinfrastructuurInDeBuurt.lengtegraad = this.state.newCoordinatesInfrastructuur.lng;

		this.setState({
			currentSportinfrastructuurInDeBuurt: currentSportinfrastructuurInDeBuurt,
			inEditMode: false
		});
	}

	handleOnCancelLocatie() {
		this.resetStateInfrastructuurLocatie();
	}

	resetStateInfrastructuurLocatie() {
		this.setState({
			sportInfrastructuurCenterCoordinaten: null, // reset and hide map
			sportInfrastructuurAanvraagCoordinaten: null, // reset and hide map
			newCoordinatesInfrastructuur: null,
			hasUnsavedChanges: false,
			inEditMode: false
		});
	}

	handleOnRemoveSportInfrastructuur(event, i, infraBinnen600m) {
		this.setState({ removeModalIsOpen: true, removeInfraIndex: i, infraBinnen600m });
	}

	handleOnGoToRemoveSportInfrastructuur() {
		const i = this.state.removeInfraIndex;
		const simulatiePerInfrastructuur = this.state.simulatiePerInfrastructuur;
		const infraBinnen600m = this.state.infraBinnen600m;
		const sportinfrastructurenInDeBuurt = infraBinnen600m.toString() === "true" ? orderByPropertyName(simulatiePerInfrastructuur.sportinfrastructurenInDeBuurt.filter(i => i.behoortTotMijnProject === false && i.tienMinutenWandelen), "naam") : orderByPropertyName(simulatiePerInfrastructuur.sportinfrastructurenInDeBuurt.filter(i => i.behoortTotMijnProject === false && i.tienMinutenWandelen === false), "naam");
		const sportInfraId = sportinfrastructurenInDeBuurt[i].id;
		const infraindex = simulatiePerInfrastructuur.sportinfrastructurenInDeBuurt.indexOf(simulatiePerInfrastructuur.sportinfrastructurenInDeBuurt.find(x => x.id === sportInfraId));
		simulatiePerInfrastructuur.sportinfrastructurenInDeBuurt.splice(infraindex, 1);
		simulatiePerInfrastructuur.sportinfrastructurenOpKaart.splice(infraindex, 1);

		//TODO ERWIN REMOVE
		this.props.removeInfrastructuurInDeBuurt(sportInfraId);

		return this.setState({
			removeModalIsOpen: false,
			removeInfraIndex: null,
			simulatiePerInfrastructuur: simulatiePerInfrastructuur,
			hasUnsavedChanges: true,
			currentSportinfrastructurenInDeBuurtIndex: null,
			currentSportinfrastructuurInDeBuurt: null
		});
	}

	handleOnCancelRemoveSportInfrastructuur() {
		this.setState({ removeModalIsOpen: false, removeInfraIndex: null });
	}

	handleOnChangeInfrastructuur(event, i) {
		const currentSportinfrastructuurInDeBuurt = this.state.currentSportinfrastructuurInDeBuurt;
		const field = event.target.name;
		currentSportinfrastructuurInDeBuurt[field] = event.target.value;

		return this.setState({
			currentSportinfrastructuurInDeBuurt: currentSportinfrastructuurInDeBuurt,
			hasUnsavedChanges: true
		});
	}

	handleOnClickTooltip(value, i) {
		if (i != -1) {
			const simulatiePerInfrastructuur = this.state.simulatiePerInfrastructuur;

			simulatiePerInfrastructuur.sportinfrastructurenOpKaart[i] = Object.assign(simulatiePerInfrastructuur.sportinfrastructurenOpKaart[i], { tooltip: value });
			this.setState({ simulatiePerInfrastructuur: simulatiePerInfrastructuur });
		} else {
			this.setState({ tooltip: value });
		}
	}

	handleOnAddInfrastructuur() {
		return this.setState({
			addModalIsOpen: true
		});
	}

	handleOnCancelInfrastruur() {
		let simulatiePerInfrastructuur = mergeDeep({}, this.state.simulatiePerInfrastructuur);
		let indexToCancel = simulatiePerInfrastructuur.sportinfrastructurenInDeBuurt.length - 1;

		if (indexToCancel > -1 && this.state.isNew)
			simulatiePerInfrastructuur.sportinfrastructurenInDeBuurt.splice(indexToCancel, 1);

		this.pageHelper.loadLayout();

		this.setState({
			simulatiePerInfrastructuur: simulatiePerInfrastructuur,
			showEditInfrastructuurForm: false,
			currentSportinfrastructuurInDeBuurt: null,
			currentSportinfrastructurenInDeBuurtIndex: null,
			hasUnsavedChanges: false
		});
	}

	handleOnChangeAdres(event, data, i) {
		const field = event.target.name;
		const currentSportinfrastructuurInDeBuurt = this.state.currentSportinfrastructuurInDeBuurt;

		if (data != null) {
			let label = "";
			let item = null;
			if (data.name === "gemeente") {
				item = this.props.gemeenten.find(item => item.value == data.value);

			} else {
				item = this.props.postcodes.find(item => item.value == data.value);

			}
			if (item != null) {
				label = item.label;
			}
			currentSportinfrastructuurInDeBuurt[data.name] = label;
		}
		else {
			currentSportinfrastructuurInDeBuurt[field] = event.target.value;
		}

		this.clearBreedteEnLengtegraad(currentSportinfrastructuurInDeBuurt);

		this.setState({
			currentSportinfrastructuurInDeBuurt: currentSportinfrastructuurInDeBuurt,
			hasUnsavedChanges: true
		});
	}

	clearBreedteEnLengtegraad(sportinfra) {
		if (sportinfra.breedtegraad != "" || sportinfra.lengtegraad != "") {
			sportinfra.breedtegraad = "";
			sportinfra.lengtegraad = "";
		}
	}

	handleOnGetGeoCoordinates() {
		const currentSportinfrastructuurInDeBuurt = this.state.currentSportinfrastructuurInDeBuurt;
		const simulatiePerInfrastructuur = this.state.simulatiePerInfrastructuur;

		let adres = {
			gemeenteId: currentSportinfrastructuurInDeBuurt.gemeente,
			postcodeId: currentSportinfrastructuurInDeBuurt.postcode,
			straatHuisnummer: currentSportinfrastructuurInDeBuurt.straatHuisnummer
		};

		this.props.getGeoCoordinates(adres).then(result => {
			if (result.lengtegraad && result.breedtegraad) {
				this.setState({
					sportInfrastructuurAanvraagCoordinaten: Object.assign({}, { lat: simulatiePerInfrastructuur.breedtegraad, lng: simulatiePerInfrastructuur.lengtegraad }),
					sportInfrastructuurCenterCoordinaten: Object.assign({}, { lat: result.breedtegraad, lng: result.lengtegraad }),
					newCoordinatesInfrastructuur: Object.assign({}, { lat: result.breedtegraad, lng: result.lengtegraad }),
					hasUnsavedChanges: true,
					currentSportinfrastructuurInDeBuurt: Object.assign(currentSportinfrastructuurInDeBuurt, { breedtegraad: result.breedtegraad, lengtegraad: result.lengtegraad }),
					infrastructuurMapKey: GenerateGuid()
				});

			} else {

				this.setState({
					sportInfrastructuurAanvraagCoordinaten: Object.assign({}, { lat: simulatiePerInfrastructuur.breedtegraad, lng: simulatiePerInfrastructuur.lengtegraad }),
					sportInfrastructuurCenterCoordinaten: Object.assign({}, { lat: simulatiePerInfrastructuur.breedtegraad, lng: simulatiePerInfrastructuur.lengtegraad }),
					newCoordinatesInfrastructuur: Object.assign({}, { lat: simulatiePerInfrastructuur.breedtegraad, lng: simulatiePerInfrastructuur.lengtegraad }),
					hasUnsavedChanges: true,
					infrastructuurMapKey: GenerateGuid()
				});
			}
		});
	}

	handleOnEdit(event, id) {
		const simulatiePerInfrastructuur = this.state.simulatiePerInfrastructuur;
		const sportinfrastructurenInDeBuurt = simulatiePerInfrastructuur.sportinfrastructurenInDeBuurt;
		const infrasInDeBuurt = sportinfrastructurenInDeBuurt.map(i => i.id);
		const currentSportinfrastructuurInDeBuurt = Object.assign({}, sportinfrastructurenInDeBuurt.filter(i => i.id === id).length > 0 ? Object.assign({}, sportinfrastructurenInDeBuurt.find(i => i.id === id)) : Object.assign({}, sportinfrastructurenInDeBuurt[id]));
		const currentSportinfrastructurenInDeBuurtIndex = infrasInDeBuurt.indexOf(currentSportinfrastructuurInDeBuurt.id);

		this.setState({
			simulatiePerInfrastructuur: simulatiePerInfrastructuur,
			currentSportinfrastructurenInDeBuurtIndex: currentSportinfrastructurenInDeBuurtIndex,
			currentSportinfrastructuurInDeBuurt: currentSportinfrastructuurInDeBuurt,
			hasUnsavedChanges: true,
			showEditInfrastructuurForm: true,
			isNew: false,
			sportInfrastructuurCenterCoordinaten: Object.assign({}, { lat: currentSportinfrastructuurInDeBuurt.breedtegraad, lng: currentSportinfrastructuurInDeBuurt.lengtegraad }),
			newCoordinatesInfrastructuur: Object.assign({}, { lat: currentSportinfrastructuurInDeBuurt.breedtegraad, lng: currentSportinfrastructuurInDeBuurt.lengtegraad }),
			sportInfrastructuurAanvraagCoordinaten: Object.assign({}, { lat: currentSportinfrastructuurInDeBuurt.breedtegraad, lng: currentSportinfrastructuurInDeBuurt.lengtegraad })
		});

		this.props.loadSimulatiePerInfrastructuurEditInfrastructuurLayout();
	}

	handleOnReplacePoint() {
		this.setState({
			inEditMode: true
		});
	}


	handleOnSaveNewPointStep1(event) {
		this.setState({
			showModalOnSaveNewPoint: true
		});
	}

	handleOnSaveNewPointStep2(event) {
		let newSimulatiePerInfrastructuur = Object.assign({}, this.state.simulatiePerInfrastructuur, { breedtegraad: parseFloat(this.state.newCoordinates.lat), lengtegraad: parseFloat(this.state.newCoordinates.lng) });

		this.setState({
			simulatiePerInfrastructuur: newSimulatiePerInfrastructuur,
			inEditMode: false,
			mapKey: GenerateGuid(),
			showModalOnSaveNewPoint: false
		}, this.handleOnSave(newSimulatiePerInfrastructuur));
	}

	handleOnCancelReplace() {
		let originalCoordinates = Object.assign({}, { lat: parseFloat(this.state.simulatiePerInfrastructuur.breedtegraad), lng: parseFloat(this.state.simulatiePerInfrastructuur.lengtegraad) });
		this.setState({
			inEditMode: false,
			center: originalCoordinates,
			newCoordinatesInfrastructuur: originalCoordinates
		});
	}

	handleOnDragEnd(e) {
		const movedMarker = mergeDeep({}, this.state.newCoordinatesInfrastructuur);

		movedMarker.lat = e.target.getLatLng().lat;
		movedMarker.lng = e.target.getLatLng().lng;

		this.setState({
			newCoordinatesInfrastructuur: movedMarker
		});
	}

	handleOnShowLegend(event) {
		this.pageHelper.showLegend(event);
	}

	handleOnHideLegend(event) {
		this.pageHelper.hideLegend(event);
	}

	handleOnGoToAddSportInfrastructuur() {
		this.props.getEmptySportinfrastructuurInDeBuurt()
			.then(empty => {
				let simulatiePerInfrastructuur = mergeDeep({}, this.state.simulatiePerInfrastructuur);

				empty.simulatieDossierId = simulatiePerInfrastructuur.dossier.id;
				empty.straatHuisnummer = simulatiePerInfrastructuur.straatHuisnummer;
				empty.postcode = simulatiePerInfrastructuur.postcode;
				empty.gemeente = simulatiePerInfrastructuur.gemeente;
				empty.lengtegraad = simulatiePerInfrastructuur.lengtegraad;
				empty.breedtegraad = simulatiePerInfrastructuur.breedtegraad;
				simulatiePerInfrastructuur.sportinfrastructurenInDeBuurt.push(empty);
				simulatiePerInfrastructuur.sportinfrastructurenOpKaart.push(empty);

				this.props.loadSimulatiePerInfrastructuurEditInfrastructuurLayout();

				return this.setState({
					simulatiePerInfrastructuur: simulatiePerInfrastructuur,
					hasUnsavedChanges: true,
					addModalIsOpen: false,
					currentSportinfrastructuurInDeBuurt: Object.assign({}, empty),
					currentSportinfrastructurenInDeBuurtIndex: (simulatiePerInfrastructuur.sportinfrastructurenInDeBuurt.length - 1),
					isNew: true,
					sportInfrastructuurCenterCoordinaten: Object.assign({}, { lat: simulatiePerInfrastructuur.breedtegraad, lng: simulatiePerInfrastructuur.lengtegraad }),
					showEditInfrastructuurForm: true,
					newCoordinatesInfrastructuur: Object.assign({}, { lat: simulatiePerInfrastructuur.breedtegraad, lng: simulatiePerInfrastructuur.lengtegraad }),
					sportInfrastructuurAanvraagCoordinaten: Object.assign({}, { lat: simulatiePerInfrastructuur.breedtegraad, lng: simulatiePerInfrastructuur.lengtegraad })
				});
			});
	}

	handleOnCancelAddSportInfrastructuur() {
		this.setState({ addModalIsOpen: false });
	}

	render() {
		if (!this.pageHelper.isReadyToRender())
			return null;

		const { simulatiePerInfrastructuur } = this.state;
		const disabled = this.props.disabled || (this.state.simulatiePerInfrastructuur && this.state.simulatiePerInfrastructuur.redenVanStatus == 121450001);
		const showEditInfrastructuurForm = this.state.showEditInfrastructuurForm;
		const currentSportinfrastructuurInDeBuurt = this.state.currentSportinfrastructuurInDeBuurt;

		const {
			maxMapFeaturesToLoad,
			osmBaseLayerUrl
		} = this.props;

		const simulatieDossierFormProps = {
			simulatiePerInfrastructuur: simulatiePerInfrastructuur,
			infrastructuur: this.props.infrastructuur,
			disabled: disabled,
			errors: this.state.errors,
			validationMessageType: this.state.validationMessageType,
			onChange: this.handleOnChange,
			onSave: this.handleOnSave,
			color: types.COLOR_BLUE,
			gemeenten: this.props.gemeenten,
			postcodes: this.props.postcodes,
			soortenInfrastructuur: this.props.soortenInfrastructuur,
			soortenInfrastructuurAll: this.props.soortenInfrastructuurAll,
			center: this.state.center,
			inEditMode: this.state.inEditMode,
			onClickTooltip: this.handleOnClickTooltip,
			tooltip: this.state.tooltip,
			onAddInfrastructuur: this.handleOnAddInfrastructuur,
			onChangeAdres: this.handleOnChangeAdres,
			onRemoveSportInfrastructuur: this.handleOnRemoveSportInfrastructuur,
			onEdit: this.handleOnEdit,
			showModalOnSaveNewPoint: this.state.showModalOnSaveNewPoint,
			newCoordinates: this.state.newCoordinates,
			mapKey: this.state.mapKey,
			onBevestigLocatie: this.handleOnBevestigLocatie,
			onCancelLocatie: this.handleOnCancelLocatie,
			hideAndereSoortInfrastructuur: this.state.hideAndereSoortInfrastructuur,
			topSportSjabloon: this.props.topSportSjabloon,
			fileTypes: {},
			maxMapFeaturesToLoad: maxMapFeaturesToLoad,
			osmBaseLayerUrl: osmBaseLayerUrl
		};

		let removeText = "";

		if (this.state.removeModalIsOpen.toString() === "true")
			removeText = this.state.infraBinnen600m.toString() === "true" ? `Wil je de manueel toegevoegde sportinfrastructuur ${orderByPropertyName(this.state.simulatiePerInfrastructuur.sportinfrastructurenInDeBuurt.filter(i => i.behoortTotMijnProject === false && i.tienMinutenWandelen), "naam")[this.state.removeInfraIndex].naam} verwijderen ?` : `Wil je de manueel toegevoegde sportinfrastructuur ${orderByPropertyName(this.state.simulatiePerInfrastructuur.sportinfrastructurenInDeBuurt.filter(i => i.behoortTotMijnProject === false && i.tienMinutenWandelen === false), "naam")[this.state.removeInfraIndex].naam} verwijderen ?`;

		return (<div>
			<ConfirmModal
				hookToTop={false}
				isOpen={this.state.removeModalIsOpen}
				title="Opgelet:"
				mainText={removeText}
				confirmAction={this.handleOnGoToRemoveSportInfrastructuur}
				confirmText="Ga verder"
				cancelText="Terug"
				cancelAction={this.handleOnCancelRemoveSportInfrastructuur} />
			<ConfirmModal
				hookToTop={false}
				isOpen={this.state.addModalIsOpen}
				title="Opgelet:"
				mainText="Hier mag je enkel een infrastructuur toevoegen die zich binnen een straal van 600m bevindt."
				confirmAction={this.handleOnGoToAddSportInfrastructuur}
				confirmText="Ga verder"
				cancelText="Terug"
				cancelAction={this.handleOnCancelAddSportInfrastructuur} />
			{showEditInfrastructuurForm ?
				<SimulatiePerInfrastructuurEditInfrastructuurForm
					model={currentSportinfrastructuurInDeBuurt}
					color={types.COLOR_BLUE}
					isNew={this.state.isNew}
					isSpakki={currentSportinfrastructuurInDeBuurt.spakki && currentSportinfrastructuurInDeBuurt.spakki.id}
					onChange={this.handleOnChangeInfrastructuur}
					soortenInfrastructuur={this.props.soortenInfrastructuur}
					gemeenten={this.props.gemeenten}
					postcodes={this.props.postcodes}
					mapKey={this.state.infrastructuurMapKey}
					mapEditMode={this.state.inEditMode}
					mapCenter={this.state.sportInfrastructuurCenterCoordinaten}
					mapNewCoords={this.state.newCoordinatesInfrastructuur}
					onSave={this.handleOnSaveSimulatiePerInfrastructuur}
					onCancel={this.handleOnCancelInfrastruur}
					onReplacePoint={this.handleOnReplacePoint}
					onSaveNewPoint={this.handleOnBevestigLocatie}
					onCancelReplace={this.handleOnCancelReplace}
					onGetGeoCoordinates={this.handleOnGetGeoCoordinates}
					errors={this.props.infrastructuurInDeBuurtErrors}
					validationMessageType={this.props.validationMessageType}
					infrastructuurAanvraagCoordinaten={this.state.sportInfrastructuurAanvraagCoordinaten}
					hideAndereSoortInfrastructuur={this.state.hideAndereSoortInfrastructuur}
					center={this.state.center}
					maxMapFeaturesToLoad={maxMapFeaturesToLoad}
					osmBaseLayerUrl={osmBaseLayerUrl}
					onMarkerDragEnd={this.handleOnDragEnd}
				/>
				:
				<SimulatiePerInfrastructuurForm {...simulatieDossierFormProps} />
			}
		</div>);
	}
}

SimulatiePerInfrastructuurPage.propTypes = {
	disabled: PropTypes.bool,
	loadLayout: PropTypes.func.isRequired,
	soortenInfrastructuur: PropTypes.array.isRequired,
	soortenInfrastructuurAll: PropTypes.array.isRequired,
	simulatieDossierId: PropTypes.string,
	topSportSjabloon: PropTypes.string.isRequired
};

function mapStateToProps(state, ownProps) {
	const simulatieDossierId = ownProps.params.simulatieDossierId;
	const infrastructuurId = ownProps.params.infrastructuurId;
	const disabled = state.ajaxCounter > 0;
	const isNew = !simulatieDossierId;

	return {
		isNew,
		disabled: disabled,
		simulatieDossierId: simulatieDossierId,
		infrastructuurId: infrastructuurId,
		infrastructuur: state.infrastructuren.find(i => i.id == infrastructuurId),
		postcodes: convertToLabelValuePair(state.referentie.postcodes),
		gemeenten: convertToLabelValuePair(state.referentie.gemeenten),
		soortenInfrastructuur: state.referentie.soortenInfrastructuur,
		soortenInfrastructuurAll: state.referentie.soortenInfrastructuurAll,
		topSportSjabloon: state.settings.topSportSjabloon,
		simulatiePerInfrastructuur: state.simulatiePerInfrastructuurModal,
		infrastructuurInDeBuurtErrors: state.simulatiePerInfrastructuurModal.infrastructuurInDeBuurtErrors,
		validationMessageType: state.simulatiePerInfrastructuurModal.validationMessageType,
		maxMapFeaturesToLoad: state.settings.maxMapFeaturesToLoad,
		osmBaseLayerUrl: state.settings.osmBaseLayerUrl
	};
}


function mapDispatchToProps(dispatch, ownProps) {
	return {
		getGeoCoordinates: bindActionCreators(simulatiePerInfrastructuurActions.getGeoCoordinates, dispatch),
		getEmptySportinfrastructuurInDeBuurt: bindActionCreators(simulatiePerInfrastructuurActions.getEmptySportinfrastructuurInDeBuurt, dispatch),
		loadSimulatiePerInfrastructuurEditInfrastructuurLayout: bindActionCreators(layoutActions.loadSimulatiePerInfrastructuurEditInfrastructuurLayout, dispatch),
		saveSimulatiePerInfrastructuur: bindActionCreators(simulatiePerInfrastructuurActions.saveSimulatietPerInfrastructuurCache, dispatch),
		removeInfrastructuurInDeBuurt: bindActionCreators(simulatieDossierActions.simulatieInfrastructuurRemoved, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(SimulatiePerInfrastructuurPage));
